var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"officemanagement"}},[_c('NavBarHome'),_c('br'),_c('v-container',[_c('v-row',[_c('TreeView')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }